import * as React from 'react'
import { connect } from 'react-redux'

import { Header } from './header'
import { formSelector } from '../../selectors/forms'
import { MainMenu } from '../mainmenu/menu'
import { Container } from '../container'
import { RootState } from '../../types/rootstate'
import { strings } from '../../lib/localization'

interface StateProps {
  form: RootState['forms']['key']
}

interface DispatchProps {}

interface OwnProps {
  thankyouMsg: string
}

type ThankYouProps = StateProps & DispatchProps & OwnProps

function mapStateToProps (state: RootState, ownProps: any): StateProps {
  return {
    form: formSelector(state, ownProps.params.formId)
  }
}

function mapDispatchToProps (dispatch): DispatchProps {
  return {}
}

interface ThankYouState {}

class ThankYouComponent extends React.Component<ThankYouProps, ThankYouState> {
  render () {
    let text = {
      __html: strings.customFormSubmitSuccess
    }
    if (this.props.form && this.props.form.thankyouText) {
      text = {
        __html: this.props.form && this.props.form.thankyouText
      }
    }
    return <Container name='forms'>
      <Header />
      <div className='imbox-forms-wrapper'>
        <div className='container'>
          <div className='row'>
            <div className='col-xs-12 thankYouMsg' dangerouslySetInnerHTML={text}/>
          </div>
        </div>
      </div>
    </Container>
  }
}

const ThankYou = connect<StateProps, DispatchProps, OwnProps>(mapStateToProps, mapDispatchToProps)(ThankYouComponent)

export {
  ThankYou
}
